import React from 'react';

export default React.createContext({
  nextMenuItem: null,
  prevMenuItem: null,
});
